module.exports = __webpack_public_path__ + "static/media/binario.6670d50e.JPG";